import { render } from "./TariffPaymentStatus.vue?vue&type=template&id=775ace62"
import script from "./TariffPaymentStatus.vue?vue&type=script&lang=js"
export * from "./TariffPaymentStatus.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__